export function getExponentialBackoffDelay(attempt: number, initialDelay: number, maxDelay = 60000) {
  if (attempt < 1) {
    throw Error('Attempt starting at 1');
  }
  return Math.min(2 ** (attempt - 1) * initialDelay, maxDelay);
}
